import React from 'react';
import { motion } from 'framer-motion';
import { ConsultationForm } from './ConsultationForm';
export function BottomCTASection() {
  return <section className="w-full bg-[var(--color-navy)]" data-id="element-50" data-mp="1y4yqoalp1ryx">
      <div className="mx-auto w-full max-w-3xl px-4 py-16 text-center sm:px-6 sm:py-20 lg:px-8" data-id="element-51" data-mp="22wqck7twn9iq">
        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5
      }} className="font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-52" data-mp="27ww4lp436y1c">
          Schedule Your Free Website Consultation
        </motion.h2>
        <div className="mt-10 text-left" data-id="element-53" data-mp="1p5vbhhpndwpp">
          <ConsultationForm formId="bottom" heading="Get Your Free Website Consultation" data-id="element-54" data-mp="1p6wovsu4yval" />
        </div>
      </div>
    </section>;
}